exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arc path{stroke:#fff;stroke-width:0.75;fill:none;cursor:pointer}.arc text{font-size:12px;font-weight:500;fill:#fff}.legendPie{padding-right:20px}.legendPie-parent{display:grid;grid-template-columns:repeat(4, auto);text-align:left}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/drillDownPie/drillDown.scss
// module id = 613
// module chunks = 0